/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from './SectionCard';

const JOUR_FIN_DE_MOIS =
  "Quand nous parlons d'échéance, le nombre de jours fin de mois désigne le nombre de jours maximum pour payer la facture à partir du dernier jour du mois où la facture a été émise. Exemple : si une facture a été émise le 12/01/2022 et qu'elle est payable à 90 jours fin de mois, la date maximum d'échéance pour le paiement de cette facture est le 30/04/2022.";

const RECEPTION_REGLEMENT =
  "Merci de noter que nous exigeons que la réception des pièces de règlements se fasse à 10 jours fin de mois. Exemple : si une facture a été émise le 12/01/2022, le client devra établir et nous envoyer une pièce de règlement relative à cette facture au plus tard le 10/02/2022, peu importe l'échéance de paiement de cette pièce de règlement.";

const InfoLine = ({ label, text }) => (
  <Box sx={{ mb: '8px' }}>
    <Typography component="span" sx={{ fontSize: '13px', color: '#007BC6', fontWeight: 600 }}>
      {label}{' '}
    </Typography>
    <Typography component="span" sx={{ fontSize: '13px', color: '#4D4D4D' }}>
      {text}
    </Typography>
  </Box>
);

const PaymentSection = ({ data }) => (
  <SectionCard id="condition-de-paiement" title="Conditions de paiement">
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '40px', mb: '20px', flexWrap: 'wrap' }}>
      <Typography sx={{ fontSize: '14px', color: '#4D4D4D' }}>
        Mode de paiement :{' '}
        <Box component="span" sx={{ color: '#007BC6', fontWeight: 600 }}>{data.modePaiement}</Box>
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#4D4D4D' }}>
        Échéance pièces moteur (PM) :{' '}
        <Box component="span" sx={{ color: '#007BC6', fontWeight: 600 }}>{data.echeancePm}</Box>
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#4D4D4D' }}>
        Échéance huile (H) :{' '}
        <Box component="span" sx={{ color: '#007BC6', fontWeight: 600 }}>{data.echeanceHuile}</Box>
      </Typography>
    </Box>

    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1A2B3C', mb: '14px' }}>
      Informations:
    </Typography>

    <InfoLine label="Jour fin de mois" text={JOUR_FIN_DE_MOIS} />
    <InfoLine label="Réception règlement" text={RECEPTION_REGLEMENT} />
  </SectionCard>
);

export default PaymentSection;